// API toolsettings data
export const getActiveToolIDs = (toolSettings: Record<number, boolean>): number[] => {
    return Object.keys(toolSettings)
    .filter((toolID) => toolSettings[Number(toolID)])
    .map(Number);
};
// Learning Coach Community 
export const shouldShowLearningCoachCommunity = (userRoleVal: string, activeToolIDs: number[]): boolean => {
    return userRoleVal === 'LEARNING_COACH' && (activeToolIDs.includes(128) || activeToolIDs.includes(166));
};
// Hang Out in the K12 Zone (for LC or Student Role, Tool ID 182 required)
export const shouldShowK12Zone = (userRoleVal: string, activeToolIDs: number[]): boolean => {
    return (userRoleVal === 'LEARNING_COACH' || userRoleVal === 'STUDENT') && activeToolIDs.includes(182);
};

/** Teachers preview the welcome site as a student would see it. */
export const studentPreviewRole = (userRoleVal: string): string =>
    userRoleVal === 'TEACHER' ? 'STUDENT' : userRoleVal;

export const isTeacherPreview = (userRoleVal: string): boolean => userRoleVal === 'TEACHER';

/** Synthetic `identityId` on teacher school preview rows — not valid for student-scoped relay APIs. */
export const TEACHER_PREVIEW_IDENTITY_PREFIX = 'teacher-school-';

export function isTeacherPreviewIdentityId(identityId: string | null | undefined): boolean {
  return String(identityId ?? '').startsWith(TEACHER_PREVIEW_IDENTITY_PREFIX);
}

/** Skip GET `/tasks`, shipping, and similar APIs that require a real student identity. */
export function shouldSkipStudentScopedBackendApi(
  identityId: string | null | undefined,
  userRoleVal?: string
): boolean {
  return isTeacherPreview(userRoleVal ?? '') || isTeacherPreviewIdentityId(identityId);
}

/** Matches `demoStudent.json` — K-5 band for CMS secondary-page `displayConditions`. */
export const TEACHER_PREVIEW_DEFAULT_GRADE_ID = '5';

const INVALID_CMS_GRADE_IDS = new Set(['', '—', '-']);

export function isInvalidGradeIdForCms(gradeId: string | undefined): boolean {
  const g = gradeId?.trim() ?? '';
  return !g || INVALID_CMS_GRADE_IDS.has(g);
}

/** CMS grade-band filters need a real grade; teacher school previews use a placeholder dash. */
export function tasklistDisplayGradeId(
  gradeId: string | undefined,
  accountRoleVal: string
): string | undefined {
  if (isTeacherPreview(accountRoleVal) && isInvalidGradeIdForCms(gradeId)) {
    return TEACHER_PREVIEW_DEFAULT_GRADE_ID;
  }
  const trimmed = gradeId?.trim();
  return trimmed || gradeId;
}
